<template>
  <div>
      <div class="container fs-16">
        <div class="logo mb-20 py-20"><img src="https://sky-production.s3.amazonaws.com/properties/2789/1634752791_JICR_HORZ.png" /></div>
        <div class="connect-method-form">
          <div class="mb-20">
            <input v-model="form.first_name" type="text" placeholder="First Name" />
          </div>
          <div class="mb-20">
            <input v-model="form.last_name" type="text" placeholder="Last Name" />
          </div>
          <div class="mb-20">
            <input v-model="form.email_address" type="text" placeholder="Email" />
          </div>
          <div class="mb-20 fs-14">
            <label class="d-flex align-items-start"><input v-model="subscribe" type="checkbox" /><span class="ml-5">I would like to receive marketing communications from the Jekyll Island Club Resort.</span></label>
          </div>
          <div class="mb-20 fs-14">
            <TermsOfService variant="checkbox" consent_text="I AGREE TO THE" consent_action_text="TERMS &amp; CONDITIONS" @onChangeCheckboxConsent="handleOnChangeCheckboxConsent" />
          </div>
          <div class="">
            <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Continue</button>
          </div>

        </div>
        <div class="py-30">
          <SupportAndDeviceInfo :phone="portal.template.support_phone" :ip="connection_data.client_ip" :mac="connection_data.client_mac" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TermsOfService from '@/utilities/TermsOfService'
  import SupportAndDeviceInfo from '@/utilities/SupportAndDeviceInfo'
  import Axios from "axios";

  export default {
    name: 'custom_template_jekyl',
    props: [ 'template', 'portal', 'connection_data'],
    components: { TermsOfService, SupportAndDeviceInfo },
    computed: {
      show_continue:function(){
        return (this.consent && !this.subscribe) || (this.consent && this.subscribe && this.form.first_name && this.form.last_name && this.form.email_address);
      },
    },
    data(){
      return{
        revinate_token: 'a506b9cd-133e-490f-a8d6-17dbebced0c2',
        revinate_url: 'https://contact-api.inguest.com/api/add-contacts-to-lists',
        disabled: true,
        connect_method: null,
        consent: false,
        subscribe: true,
        form: {
          // access_code: null,
          room_number: null,
          first_name: null,
          last_name: null,
          email_address: null,
        },
      }
    },
    watch: {
      'form': {
        deep: true,
        handler(){ this.disabled = false }
      }
    },
    created(){
      document.documentElement.classList.add('jekylIsland');
    },
    methods: {
      handleOnChangeCheckboxConsent(value){
        this.consent = value;
      },
      handleClickMethod(method=null){
        this.disabled = false;
        this.connect_method = method;
        this.consent = false;
        this.subscribe = false;
        this.form.room_number = null;
        this.form.first_name = null;
        this.form.last_name = null;
        this.form.email_address = null;

      },
      setRegistrationData(){

        const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 1);
        const rateplan_id = registration_method.rate_plans[0].rateplan_id;
        return {
          registration_method_id: 1,
          rateplan_id: rateplan_id,
          ...(this.form.first_name && { first_name: this.form.first_name }),
          ...(this.form.last_name && { last_name: this.form.last_name }),
          ...(this.form.email_address && { email_address: this.form.email_address }),
        }
        
      },
      handleClickConnect: function(){
        this.disabled = true;
        const data = this.setRegistrationData();
        if(this.form.email_address){
          const revinate_data = {
            tokens: [ this.revinate_token ],
            contacts: [
              {
                ...(this.form.first_name && { first_name: this.form.first_name }),
                ...(this.form.last_name && { last_name: this.form.last_name }),
                ...(this.form.email_address && { email: this.form.email_address }),
                 subscribed: this.subscribe
              }
            ]
          };
          Axios.post(this.revinate_url,revinate_data).then(response => {
            this.$emit('emitRegistrationMethodData', data );
          }).catch( error => {
            this.$emit('error', 'Error registering with email address.');
          });
        } else {
          this.$emit('emitRegistrationMethodData', data );
        }
      },
    }
  }
  </script>
  <style>
  .jekylIsland { overflow-y: scroll; min-height: 100%; background: #fff; font-size: 20px;  }
  .jekylIsland body { min-height: 100vh; background-image: url(https://sky-production.s3.amazonaws.com/properties/2789/1634752709_JIC_Clubhouse_Drone_2.jpg), url(https://sky-production.s3.amazonaws.com/properties/2789/1634752709_JIC_Clubhouse_Drone_2.jpg); background-position: left top, left top; background-repeat: repeat-x, repeat; }
  .jekylIsland .logo {text-align: center; margin-top: 5%;}
  .jekylIsland .logo img {width:  100%; margin-top: 20px;}
  .jekylIsland .container { background-color: #fffffff2; border-radius: 15px; padding: 0 50px;}
  .jekylIsland .connect-method-form { width: 100%; text-align: left;  }
  .jekylIsland #app, .jekylIsland button, .jekylIsland input[type="text"] { color: #000; border-radius: 5px;}
  .jekylIsland button { border: unset; cursor: pointer; line-height: 1; background: #1b355e; color: #ffffff; font-weight: bold; width: 100%; margin-top: 20px; padding: 20px 0; font-size: 16px; text-transform: uppercase;  }
  .jekylIsland button[disabled] { cursor: not-allowed; }
  .jekylIsland input[type="text"] { padding: 15px; font-size: 14px; border: none; width: 100%; background: #eee;}
  .jekylIsland .d-block { display: block; }
  .jekylIsland a { color: #6B6B6B; }
  .jekylIsland a:hover { color: #1a1a1a; }
  </style>
  